import React from 'react';
import withIcon from '../utilities/withIcon';

const IconStarFilled = () => {
  return (
    <g>
      <path d="m15.874 6.13a.7507.7507 0 0 0 -.7139-.5191h-4.8388l-1.6152-4.5137a.75.75 0 0 0 -1.4121 0l-1.6163 4.5141h-4.8377a.75.75 0 0 0 -.44 1.3575l3.807 2.7548-1.6728 4.6739a.75.75 0 0 0 1.1162.8809l4.3496-2.8399 4.3486 2.84a.75.75 0 0 0 1.1162-.8809l-1.6728-4.6735 3.808-2.7554a.75.75 0 0 0 .274-.8387z" />
    </g>
  );
};

export default withIcon(IconStarFilled);
